import React, { Component } from 'react';
import axios from 'axios';
import {path,storeImagePath} from './routes.js';
import Submit from '../component/Submit.js';
import SelectBox from '../component/Select.js';
import ManageTiers from './ManageTiers.js'; //container for viewing, creating, or editing Tiers
import ManageASMPrizes from './ManageASMPrizes.js'; //container for viewing, creating, or editing prizes/gifts
import ASMRegionalCenter from './ASMRegionalCenter.js'; //container for managing asm budgets
import ManageAdminMessages from './ManageAdminMessages.js'; //container for viewing or creating admin messages

export default class ASMAdminCenter extends Component {
	constructor(props){
		super(props);
		this.handleChoice = this.handleChoice.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.getTiers = this.getTiers.bind(this);
		this.getPrizes = this.getPrizes.bind(this);
		this.getMessages = this.getMessages.bind(this);
		this.handleReset = this.handleReset.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.goBack = this.goBack.bind(this);
		this.revertSave = this.revertSave.bind(this);
		this.state = {Tiers:[],Prizes:[],Years:[],Messages:[],category:'Budgets',year:'',create:false,edit:false,save:false};
	}

	componentDidMount(){ //when component mounts, all information regarding prizes/gifts, tiers, and admin messages are retrieved.
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'years'}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({Years:data,year:data[0].year});
			this.getPrizes(data[0].year);
			this.getTiers(data[0].year);
			this.getMessages(data[0].year);
		});
	}

	getTiers(year){ //method that handles retrieving tier information for the selected year from the database.
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'tiers',kind:'asm',year:year}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({Tiers:data});
		});
	}

	getPrizes(year){ //method that handles retrieving prize/gift information for the selected year from the database.
		let gifts = [];
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'prizes',kind:'asm',action:this.props.userInfo.userType,year:year}
		}).then((response)=>{
			let data=response.data.data;
			data.forEach((prize)=>{
				prize.picture = storeImagePath+prize.picture;
				gifts.push(prize);
			});
			this.setState({Prizes:gifts});
		});
	}

	getMessages(year){ //method that handles retrieving admin message information for the selected year from the database.
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'messages',action:'admin_center',kind:'asm_admin',year:year}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({Messages:data});
		});
	}

	componentDidUpdate(prevProps){ //once a data manipulation action has been taken, this method retrieves the current information from the database.
		if(prevProps.submitted !== this.props.submitted){
			this.getTiers(this.state.year);
			this.getMessages();
			this.getPrizes();
		}
	}

	handleChoice(identity){ //this method controls the state of the admin center, whether it is in view mode, edit mode, or create mode.
		if(identity === "create"){
			this.setState({create:true});
			this.setState({edit:false});
		}else{
			this.setState({edit:true});
			this.setState({create:false});
		}
	}

	handleSelect(identity,value){ //handleChange method for the category and year dropdown menus
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
		this.goBack();
		if(identity === "year"){ //if the year is being changed, get all information from the selected year
			this.getTiers(value);
			this.getPrizes(value);
			this.getMessages(value);
		}
	}

	handleReset(type){ //method that grabs the current version of information that was just updated from the database
		this.setState({create:false,edit:false,save:false});
		if(type === "tiers"){
			this.getTiers(this.state.year);
		}else if(type === "prizes"){
			this.getPrizes(this.state.year);
		}else if(type === "messages"){
			this.getMessages(this.state.year);
		}
	}

	goBack(){ //method sets the create, edit, and save parts of the state to their defaults
		this.setState({create:false,edit:false,save:false});
	}

	handleSave(){ //method to trigger state change for saving information that has been created or updated
		this.setState({save:true});
	}

	revertSave(){ //method to reset the save parameter of the state to its default
		this.setState({save:false});
	}

	render(){
		let dis = false;
		let inlineContent = {boxShadow:'0px 0px 5px 5px #aaaaaa inset',backgroundColor:'#e6e6e6',maxHeight:'450px'};
		let contentStyles = "b--gray fl pb4 w-100 br3 pt3 mb3 pl3 pr3 overflow-y-auto ba";
		let greaterContent;
		const {Tiers,create,edit,save,year,Prizes,Messages} = this.state;
		let content;
		const years = this.state.Years.map((Years)=>{return Years.year}); //returns an array of the current year options for year dropdown
		let categories = ["Tiers","Gifts","Messages","Budgets"]; //options for category dropdown
		const selectStyles = "h2 pa1 w-70-ns w-100 br2 bw1 truncate shadow-2";
		const labelStyle = "fl w-30 mt1";
		const selectDivStyle = "fl w-70";
		const buttonStyles ="br3 white b w-100 h2 bg-navy shadow-2";
		let prizeTiers = [];
		Tiers.forEach((tiers)=>{ //returns all active tiers for prize/gift creation
			if(tiers.tier_status !== 'inactive'){
				prizeTiers.push(tiers.tier);
			}
		});
		let createButton = <Submit name="Create" identity="create" onClick={this.handleChoice} styles={buttonStyles}/>; //default create button
		let editButton = <Submit name="Edit" identity="edit" onClick={this.handleChoice} styles={buttonStyles} disable={dis}/>; //default edit button
		if(this.state.create || this.state.edit){
			if(this.state.create){ //if the admin center is in create mode, these are the button values
				editButton = <Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>;
				createButton = <Submit name="Save" identity="save" onClick={this.handleSave} styles={buttonStyles}/>;
			}else{ //if the admin center is in edit mode, these are the button values
				if(this.state.category === "Tiers"){
					editButton = <Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>;
					createButton = <Submit name="Save" identity="save" onClick={this.handleSave} styles={buttonStyles}/>;
				}else{
					editButton = <Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>;
					createButton = <Submit name="Create" identity="create" onClick={this.handleChoice} styles={buttonStyles}/>;
				}
			}
		}
		//button original div that the buttons remain in, can change based on category chosen
		let ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
												<div className="fl w-50 tr">
													<div className="tr">
														{createButton}
													</div>
												</div>
												<div className="fl w-50">
													{editButton}
												</div>
											</div>;
		let yearSelect = <div className="fl w-50-ns w-100">
												<div className={labelStyle}>
													<label className="mt2 b">Year: </label>
												</div>
												<div className={selectDivStyle}>
													<SelectBox identity="year" options={years} onSelect={this.handleSelect} styles={selectStyles} val={this.state.year}/>
												</div>
											</div>

		switch(this.state.category){ //switch statement for rendering content based on category selection
			case "Tiers":
				content = <ManageTiers tiers={Tiers} create={create} edit={edit} save={save} revertSave={this.revertSave} year={year} app={this.props.app} reset={this.handleReset} logChange={this.props.logChange}/>;
			break;
			case "Gifts":
				content = <ManageASMPrizes prizes={Prizes} create={create} edit={edit} revertSave={this.revertSave} save={save} year={year} app={this.props.app} getPrizes={this.getPrizes}  logChange={this.props.logChange} reset={this.handleReset} tiers={prizeTiers}/>;
			break;
			case "Messages":
				content = <ManageAdminMessages messages={Messages} years={years} year={year} create={create} edit={edit} revertSave={this.revertSave} save={save} reset={this.getMessages}  logChange={this.props.logChange} userInfo={this.props.userInfo}/>;
				if(!this.state.create){ //admin messages dont have an edit option
					ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
									<div className="fl w-100">
										<div className="tc w-50 center">
											{createButton}
										</div>
									</div>
								</div>;
				}else{
					ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
								<div className="fl w-50 tr">
									<div className="tr">
										{createButton}
									</div>
								</div>
								<div className="fl w-50">
									<Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>
								</div>
							</div>;
				}
			break;
			case "Budgets":
				content = <div>
										<ASMRegionalCenter userInfo={this.props.userInfo} app={this.props.app} active={true} logChange={this.props.logSubmitted}/>
									</div>;
				ButtonGroup = '';
				yearSelect = '';

			break;
			default:
				content = <ManageTiers tiers={Tiers} create={create} edit={edit} save={save} year={year} app={this.props.app} reset={this.handleReset} logChange={this.props.logChange}/>;
		}
		
		if(this.props.active){
			greaterContent = <div className="fl w-100">
													<div className="fl w-100 mv2 pb3">
														<div className="fl w-50-ns w-100 mb1" style={{display:'inline-block'}}>
															<div className={labelStyle}>
																<label className="mt2 b">Category: </label>
															</div>
															<div className={selectDivStyle}>
																<SelectBox identity="category" options={categories} onSelect={this.handleSelect} styles={selectStyles} val={this.state.category}/>
															</div>
														</div>
														{yearSelect}
													</div>
													
													<div className={contentStyles} style={inlineContent}>
														{content}
													</div>
													{ButtonGroup}
												</div>;
		}
		return(
			<div>
			{greaterContent}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ASMAdminCenter.js